module.exports = __webpack_public_path__ + "media/images/icons/flags/CR-cc89f9988447c76eaccb3e3f24bde6c7.svg";